import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface CoPilotOnboardingStore {
  open: boolean;
  onboardingStep: number;

  handleOpenCoPilotOnboardingDialog: (onboardingDone: boolean) => void;

  handleCloseCoPilotOnboardingDialog: () => void;

  setOnboardingStep: (value: number) => void;
}

const useCoPilotOnboardingStore = createWithEqualityFn<CoPilotOnboardingStore>(
  (set) => ({
    open: false,
    onboardingStep: 0,

    handleOpenCoPilotOnboardingDialog(onboardingDone: boolean) {
      if (onboardingDone) {
        return;
      }

      const onboardingJourneysVisited = localStorage.getItem('onboardingJourneysVisited');
      const parsedOnboardingJourneysVisited: string[] = JSON.parse(onboardingJourneysVisited || '[]');

      if (!parsedOnboardingJourneysVisited.includes('co-pilot-onboarding')) {
        setTimeout(() => {
          set(() => ({ open: true }));
        }, 1500);
      }
    },

    handleCloseCoPilotOnboardingDialog() {
      const onboardingJourneysVisited = localStorage.getItem('onboardingJourneysVisited');
      const parsedOnboardingJourneysVisited: string[] = JSON.parse(onboardingJourneysVisited || '[]');

      if (!parsedOnboardingJourneysVisited.includes('co-pilot-onboarding')) {
        parsedOnboardingJourneysVisited.push('co-pilot-onboarding');
        localStorage.setItem('onboardingJourneysVisited', JSON.stringify(parsedOnboardingJourneysVisited));
      }

      set(() => ({ open: false, onboardingStep: 0 }));
    },

    setOnboardingStep(value: number) {
      set(() => ({ onboardingStep: value }));
    },
  }),
  shallow
);

export default useCoPilotOnboardingStore;
